import axios from "axios";

const accessToken =
  "pk.eyJ1IjoiZGllZ29nYXJjaWFyIiwiYSI6ImNra2VlbXUzMzExcGUyeWt4a3RoM2N0a20ifQ.0AOINLBBugdgXaGX7cSDng";
const mapStyle = "mapbox://styles/mapbox/streets-v11";

const getWikiCode = (context) => {
  const { region, country, place } = context;
  if (place.wikidata_id != null) {
    return place.wikidata_id;
  }
  if (region.wikidata_id != null) {
    return region.wikidata_id;
  }
  if (country.wikidata_id != null) {
    return country.wikidata_id;
  }
  return null;
};

const parsePlacemark = (placemark) => {
  const {
    bbox,
    context,
    full_address: fullAddress,
  } = placemark.properties;
  return {
    name: fullAddress,
    arrival_date: placemark.arrival_date,
    departure_date: placemark.departure_date,
    country_code: context.country.country_code.toUpperCase(),
    north_east: bbox != null ? { lat: bbox[3], long: bbox[2] } : null,
    south_west: bbox != null ? { lat: bbox[1], long: bbox[0] } : null,
    wiki_code: getWikiCode(context),
    center: {
      lat: placemark.properties.coordinates.latitude,
      long: placemark.properties.coordinates.longitude,
    },
  };
};
const reverseGeocode = async (lat, long) => {
  const url = `https://api.mapbox.com/search/geocode/v6/reverse?longitude=${long}&latitude=${lat}&access_token=${accessToken}`;

  const response = await axios.get(url);
  const { features } = response.data;
  if (features && features[0]) {
    const [feature] = features;
    console.log(feature);
    let city = feature.properties.name;
    if (city) {
      city = city.name;
    }
    return { ...parsePlacemark(feature), city };
  }
  throw (new Error('no results found'));
};
const getTimezoneFromGoogle = (lat, long) => {
  const url = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat}%2C${long}0&timestamp=1331161200&key=AIzaSyAg5L1YvRoH4UJ8p-o8a4FH7BGzvfWVYPA`;
  console.log(url);

  return axios.get(url).then((response) => {
    const { data } = response;
    if (data && data.timeZoneId) {
      return data.timeZoneId;
    }
    throw new Error('unknown error');
  });
};

const getTimezone = (lat, long) => {
  const url = `https://api.mapbox.com/v4/examples.4ze9z6tv/tilequery/${long},${lat}.json?access_token=${accessToken}`;
  console.log(url);
  return axios.get(url).then((response) => {
    const { data } = response;
    if (data && data.features && data.features[0]) {
      return data.features[0].properties.TZID;
    }
    console.error('no results found, using google');
    return getTimezoneFromGoogle(lat, long);
  }).catch((error) => {
    throw new Error(error.message);
  });
};

const getWikiImage = async (qCode) => {
  const url = `https://api.triploop.com/wiki_image?wikicode=${qCode}`;
  if (qCode === undefined) {
    throw new Error('no code provided');
  }
  console.log(`getting wikiimage for: ${qCode}, url:`, url);

  const response = await axios.get(url);
  const { data } = response;
  if (data.url) {
    return data.url;
  }
  console.log(data.error);
  throw new Error(data.error);
};
const createCity = (async (placemark) => {
  console.log("placemark", placemark);
  const city = parsePlacemark(placemark);
  try {
    await Promise.all([
      getTimezone(city.center.lat, city.center.long).then((timeZone) => {
        city.time_zone = timeZone;
      }),
      getWikiImage(city.wiki_code).then((url) => {
        city.image = url;
      }).catch((error) => {
        console.log(`error obtaining image${error}`);
      }),
    ]);
  } catch (error) {
    console.log(`error ${error}`);
    if (city.time_zone == null) {
      return null;
    }
  }
  return city;
});

const cityAutocomplete = async (text) => {
  const url = `https://api.mapbox.com/search/geocode/v6/forward?q=${encodeURIComponent(text)}&autocomplete=true&types=place&access_token=${accessToken}`;

  try {
    const response = await axios.get(url);
    const { data } = response;
    return data.features;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default {
  accessToken,
  mapStyle,
  reverseGeocode,
  getTimezone,
  cityAutocomplete,
  parsePlacemark,
  createCity,
  getWikiImage,
};
